var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Subject } from '@/models/Subject';
import { File as FileModel } from '@/models/File';
import ErrorHandler from '@/support/ErrorHandler';
let FileUpload = class FileUpload extends Vue {
    constructor() {
        super(...arguments);
        this.files = [];
        this.selectedFile = null;
        this.selectedFileToDelete = null;
        this.isUploading = false;
        this.isShowingDialog = false;
    }
    mounted() {
        this.fetchFiles();
    }
    fetchFiles() {
        new FileModel()
            .subject(this.subject)
            .include('user')
            .all()
            .then((files) => {
            this.files = files;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    onFileChange(event) {
        if (!event.target.files.length) {
            return;
        }
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
        this.isUploading = true;
        new FileModel()
            .subject(this.subject)
            .include('user')
            .create({ file: this.selectedFile })
            .then((file) => {
            this.files.push(file);
            this.selectedFile = null;
            this.isUploading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
            this.selectedFile = null;
            this.isUploading = false;
        });
    }
    remove(file) {
        this.selectedFileToDelete = file;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    get dialogOptions() {
        const file = this.selectedFileToDelete;
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.file') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!file) {
                            return;
                        }
                        file
                            .subject(this.subject)
                            .delete()
                            .then(() => {
                            if (file.id !== undefined) {
                                const index = this.findById(file.id);
                                this.files.splice(index, 1);
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedFileToDelete = null;
                    },
                },
            },
        };
    }
    subjectChange(newValue, oldValue) {
        this.fetchFiles();
    }
    findById(id) {
        return this.files.findIndex((file) => file.id === id);
    }
};
__decorate([
    Prop({ default: new Subject() }),
    __metadata("design:type", typeof (_a = typeof Subject !== "undefined" && Subject) === "function" ? _a : Object)
], FileUpload.prototype, "subject", void 0);
__decorate([
    Watch('subject'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FileUpload.prototype, "subjectChange", null);
FileUpload = __decorate([
    Component({
        components: {
        //
        },
    })
], FileUpload);
export default FileUpload;
